<template>
    <div class="infoengine">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-6">
                    <h2 class="filter-heading">Risk Rating Score</h2>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'tablet-table-min-width',
                'remove-sort-icon',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="scoreItems" :fields="riskRatingScoreFields">
                <template slot="generateAlert" slot-scope="data">
                    <span>
                        {{ data.value | booleanText }}
                    </span>
                </template>

                <template slot="reviewPeriod" slot-scope="data">
                    <span class="text-capitalize">
                        {{ data.value }}
                        {{ data.duration }}
                        {{
                            data.value !== 1
                                ? data.item.duration + 's'
                                : data.item.duration
                        }}
                    </span>
                </template>

                <template slot="criteria" slot-scope="data">
                    <div
                        v-if="
                            data.item &&
                                data.item.criteria &&
                                data.item.criteria.start == null
                        "
                    >
                        <span>{{ data.item.criteria.code }}</span>
                    </div>
                    <div v-else>
                        <span>{{
                            data.item.criteria && data.item.criteria.start
                        }}</span>
                        to
                        <span>{{
                            data.item.criteria && data.item.criteria.end
                        }}</span>
                        Points
                    </div>
                </template>
                <template slot="rating" slot-scope="data">
                    <base-status :status-type="data.value"></base-status>
                </template>
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-risk-rating-score-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <div class="filter-section sub-filter risk-rating-sub-heading">
            <div class="row">
                <div class="col-md-12">
                    <h2>Risk Rating Overrides</h2>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'tablet-table-min-width',
                'remove-sort-icon',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="overrideItems" :fields="riskRatingOverridesFields">
                <template slot="shouldReject" slot-scope="data">
                    <span>
                        {{ data.value | booleanText }}
                    </span>
                </template>

                <template slot="criteria" slot-scope="data">
                    <span>{{ data.item.criteria.code }}</span>
                </template>
                <template slot="rating" slot-scope="data">
                    <base-status :status-type="data.value"></base-status>
                </template>
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show(
                                    'modify-risk-rating-override-popup'
                                )
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <modify-risk-rating-score-popup></modify-risk-rating-score-popup>
        <risk-rating-override-popup></risk-rating-override-popup>
        <base-records
            path="configurations/risk-rating-scores"
            :query="query"
            :reset="reset"
            :show-pagination="false"
        ></base-records>
    </div>
</template>

<script>
import _ from 'lodash'

import { mapGetters } from 'vuex'

import modifyRiskRatingScorePopup from '@/components/popups/ModifyRiskRatingScorePopup.vue'
import riskRatingOverridePopup from '@/components/popups/RiskRatingOverridePopup.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        modifyRiskRatingScorePopup,
        riskRatingOverridePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            riskRatingScoreFields: [
                {
                    key: 'criteria',
                    label: 'POINT SCORE',
                    class: 'w-320px',
                    sortable: false,
                },
                {
                    key: 'rating',
                    label: 'RATING',
                    class: 'text-center status-absolute-pos',
                    sortable: false,
                },
                {
                    key: 'reviewPeriod',
                    label: 'REVIEW PERIOD',
                    class: 'text-center',
                    sortable: false,
                },
                {
                    key: 'generateAlert',
                    label: 'OB Alert',
                    class: 'text-center',
                    sortable: false,
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            riskRatingOverridesFields: [
                {
                    key: 'criteria',
                    label: 'Overrides',
                    class: 'w-320px',
                    sortable: false,
                },
                {
                    key: 'rating',
                    label: 'Override Rating',
                    class: 'text-center status-absolute-pos',
                    sortable: false,
                },
                {
                    key: 'shouldReject',
                    label: 'Is Rejected?',
                    class: 'text-center',
                    sortable: false,
                },

                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 100,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'criteria',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
            scoreItems: [],
            overrideItems: [],
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        data(value) {
            if (value) {
                this.overrideItems = _.filter(value, { type: 'override' })
            }
            if (value) {
                this.scoreItems = _.filter(value, { type: 'score' })
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
        }, // End of sortingChanged() method
    }, // End of Component > methods
} // End of export default
</script>
